import React from 'react';
import { MapPin, Mail, Phone } from 'lucide-react';
import johnPhoto from './assets/john.webp';
import topAgentBadge from './assets/top-agent-verified-member.webp';
import './About.css';

const About: React.FC = () => {
  return (
    <div className="about-page">
      {/* Hero Video Section */}
      <section className="video-hero">
        <div className="container">
          <div className="video-wrapper">
            <div className="video-container">
              <div className="video-placeholder">
                <div className="video-loading-text">Loading video...</div>
              </div>
              <iframe
                src="https://player.vimeo.com/video/1088608138?autoplay=1&loop=1&muted=1&controls=0&title=0&byline=0&portrait=0&badge=0&autopause=0&background=1&player_id=0&app_id=58479&transparent=0"
                frameBorder="0"
                allow="autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media"
                title="About John and Sofia"
                onLoad={(e) => {
                  const placeholder = e.currentTarget.previousElementSibling as HTMLElement;
                  if (placeholder) placeholder.style.display = 'none';
                }}
              />
            </div>
          </div>
        </div>
      </section>

      {/* About Content */}
      <section className="about-content-section section">
        <div className="container">
          <div className="about-content">
            <div className="about-text">
              <div className="story-section">
                <h2 className="story-title">More About The Team Leads John & Sophia</h2>
                <p className="story-intro">
                  We were both born and raised in the Bay Area and have watched it evolve over the years—but one thing that hasn't changed is our deep love for this community. Every neighborhood has its own story, and we believe every home does too.
                </p>
              </div>

              <div className="personal-touch">
                <p className="text-body">
                  When we work with families, we bring empathy, clarity, and a commitment to making the process as smooth and respectful as possible. Life can take unexpected turns, and we've helped people through everything from foreclosure and inheritance to divorce and job relocation.
                </p>

                <p className="text-body">
                  We know that selling a home is never just a transaction—it's often one of life's biggest decisions. You deserve a team who truly understands that and treats your situation with the care it deserves.
                </p>
              </div>

              <div className="philosophy">
                <p className="text-body philosophy-text">
                  "Every home has a story, and every family has unique needs. Our job isn't just to buy your house – it's to understand your situation and provide a solution that works for you."
                </p>
                <div className="philosophy-author">— John and Sophia</div>
              </div>

              <div className="contact-cta">
                <h3 className="cta-title">Let's Talk About Your Situation</h3>
                <p className="cta-text">No pressure, no obligation. Just a conversation about how we can help.</p>
                <div className="cta-buttons">
                  <a href="tel:+15106418133" className="btn btn-primary">
                    <Phone size={18} />
                    Call
                  </a>
                  <a href="#contact" className="btn btn-secondary">
                    <Mail size={18} />
                    Get Cash Offer
                  </a>
                </div>
              </div>
            </div>

            <div className="about-image-section">
              <div className="about-image">
                <img src={johnPhoto} alt="John and Sofia - Bay Area Cash Home Buyer" className="john-photo" />
              </div>
              <div className="credentials-sidebar">
                <div className="top-agent-badge">
                  <img src={topAgentBadge} alt="Top Agent Network Verified Member" className="badge-image" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default About; 